import { SvgIcon, SvgIconProps } from "@mui/material";

export const BackIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      aria-label="back icon"
    >
      <path
        stroke="#8C8C8C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m14 8-4 4 4 4"
      />
    </svg>
  </SvgIcon>
);
